(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["annie-utility-bar"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('annie-utility-marquee')) {
    customElements.define('annie-utility-marquee', class extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.annie-utility__track');
        this.viewport = this.querySelector('.annie-utility__viewport');
        this.copy = this.querySelector('.annie-utility__copy');
        this.button = this.querySelector('button');
        if (!this.track || !this.button) return;
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.paused = false;
        this.hovered = false;
        this.focused = false;
        this.button.addEventListener('click', () => {
          this.paused = !this.paused;
          this.button.setAttribute('aria-label', this.paused ? this.button.dataset.playLabel : this.button.dataset.pauseLabel);
          this.button.querySelector('[data-pause-icon]').hidden = this.paused;
          this.button.querySelector('[data-play-icon]').hidden = !this.paused;
          this.refresh();
        }, options);
        this.viewport.addEventListener('pointerenter', event => {
          if (event.pointerType === 'touch') return;
          this.hovered = true;
          this.animation?.pause();
        }, options);
        this.viewport.addEventListener('pointerleave', () => {
          this.hovered = false;
          this.animation?.play();
        }, options);
        this.viewport.addEventListener('focusin', () => { this.focused = true; this.refresh(); }, options);
        this.viewport.addEventListener('focusout', event => {
          if (this.viewport.contains(event.relatedTarget)) return;
          this.focused = false;
          this.refresh();
        }, options);
        this.motion.addEventListener('change', () => this.refresh(), options);
        this.observer = new ResizeObserver(() => this.refresh());
        this.observer.observe(this.viewport);
        if (document.fonts) document.fonts.ready.then(() => { if (this.isConnected) this.refresh(); });
        this.refresh();
      }
      refresh() {
        this.animation?.cancel();
        this.animation = null;
        const enabled = this.dataset.enabled === 'true' && !this.motion.matches && this.copy.textContent.trim() !== '';
        this.button.hidden = !enabled;
        const moving = enabled && !this.paused && !this.focused;
        this.toggleAttribute('data-moving', moving);
        if (!moving) return;
        const distance = this.copy.getBoundingClientRect().width;
        if (!distance) return;
        const speed = Math.max(10, Math.min(80, Number(this.dataset.speed) || 30));
        this.animation = this.track.animate([{ transform:'translateX(0)' }, { transform:`translateX(-${distance}px)` }], { duration:distance / speed * 1000, iterations:Infinity, easing:'linear' });
        if (this.hovered) this.animation.pause();
      }
      disconnectedCallback() {
        this.animation?.cancel();
        this.observer?.disconnect();
        this.controller?.abort();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
